module.exports = __webpack_public_path__ + "img/step37_a_printer_power_remove_tapes - Copy.410d1afb.png";